import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import AddBlankPagesToPDFImagesListScreen from "./AddBlankPagesToPDFImagesListScreen";
import { BASE_URL } from "../Config";

function AddBlankPagesToPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Add Blank Pages To PDF Document",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/add_pages_pdf",
      title: "Add Pages To PDF Document Online Free",
    },
    data2: { link: "/add_pages_pdf", title: "Add New Pages To PDF File Free" },
    data3: {
      link: "/add_pages_pdf",
      title: "Add Empty Pages To PDF File Online",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add blank pages to PDF online or offline easily. Insert pages into PDF files quickly, edit PDFs, and organize documents without hassle."
      ></meta>
      <meta
        name="keywords"
        content="add blank pages to pdf, insert pages into pdf, add pages to pdf online, add pages to pdf offline, edit pdf, organize pdf, pdf page inserter, pdf editor online, pdf tools, pdf management, modify pdf pages, insert blank pages in pdf, add new pages to pdf"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <AddBlankPagesToPDFImagesListScreen
          title={title}
        ></AddBlankPagesToPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Add Blank Pages to PDF File website provides a simple, secure, and efficient solution to insert blank pages into PDF documents directly on your device, without requiring an internet connection. Designed for users who value privacy and flexibility, this powerful tool allows you to add pages to PDF file, insert blank pages at any position, and organize documents exactly as needed. With offline processing, all operations are performed locally, ensuring complete data security and confidentiality without uploading files to external servers. The website also supports optional online usage, enabling users to add blank pages to PDF file for free online when internet access is available. Whether you need to insert blank pages for notes, signatures, separation of sections, or formatting requirements, this tool delivers accurate results while preserving the original document layout and quality. The platform supports add pages to PDF document for free, making it ideal for students, professionals, and businesses looking for a cost-effective PDF editing solution. Using advanced PDF page handling technology, the tool ensures text clarity, images, and formatting remain unchanged after page insertion. Compatible with desktop and mobile devices, this offline PDF page editor helps users customize documents, improve organization, and prepare PDFs for printing, sharing, or official submission. If you are searching for a reliable way to add pages to PDF file, add blank pages to PDF file for free online, or add pages to PDF document for free with complete privacy, this website offers a user-friendly and dependable PDF management experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Add Pages",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Add Blank Pages To PDF Tool"
            why_use={[
              {
                title: "Insert Space for Notes and Annotations",
                description:
                  "Sometimes PDFs need extra space for notes or comments. Using a tool to add blank pages to PDF file makes it easy to include additional writing space.",
              },
              {
                title: "Prepare PDFs for Signatures and Stamps",
                description:
                  "Official documents often require empty pages for signatures or stamps. A feature to add pages to PDF file helps prepare documents for legal and business use.",
              },
              {
                title: "Organize Large PDF Documents",
                description:
                  "Blank pages can separate sections or chapters. Tools that add pages to PDF document for free improve document structure and readability.",
              },
              {
                title: "Meet Printing and Formatting Requirements",
                description:
                  "Some printing standards require blank pages between sections. Using add blank pages to PDF file for free online ensures proper formatting.",
              },
              {
                title: "Improve Document Presentation",
                description:
                  "Adding blank pages enhances the visual flow of a PDF. A simple add pages to PDF file tool creates clean and professional-looking documents.",
              },
              {
                title: "Avoid Recreating PDF Files",
                description:
                  "Instead of rebuilding a document, you can quickly add blank pages to PDF file and update it without extra effort.",
              },
              {
                title: "Useful for Students and Professionals",
                description:
                  "Students and professionals often need extra pages for notes, explanations, or approvals. A tool to add pages to PDF document for free simplifies this task.",
              },
              {
                title: "Maintain Original Content Quality",
                description:
                  "Modern tools preserve text, images, and formatting. When you add blank pages to PDF file, the original content remains unchanged.",
              },
              {
                title: "Work Offline for Better Privacy",
                description:
                  "An offline tool allows you to add pages to PDF file securely without uploading documents to the internet.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1624184310}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default AddBlankPagesToPDFMain;
